import { Constants } from '@/assets'
import { getCurrentTimeFormatted } from './utils'

export type LogItem = { title: string; content: string | number | unknown }

/**
 * Internal class used to show decorated logs inside the console foreach Request information
 */
export class APILogger {
  static logStart(method: string | undefined, url: URL, statusCode: number) {
    if (Constants.enableRequestsLogger) {
      let color = '#b82525'
      if (statusCode >= 200 && statusCode < 300) {
        color = '#39b825'
      } else if (statusCode >= 300 && statusCode < 400) {
        color = '#b6b825'
      } else if (statusCode >= 400 && statusCode < 500) {
        color = '#b85325'
      }
      console.groupCollapsed(
        `%cEMT RM ${statusCode} %c${method} %c${url.pathname}${url.hash}${url.search} %c${getCurrentTimeFormatted()}`,
        `color: ${color}`,
        'color: black',
        'color: grey',
        'color: lightblue; font-weight: lighter;',
      )
    }
  }

  static logRequest(method: string | undefined, url: URL, bodyParams?: BodyInit | null) {
    if (Constants.enableRequestsLogger) {
      console.group(`%cRequest`, 'color: black')
      console.log(`%cFull URL: %c${url.toString()}`, 'color: grey', 'color: black')
      console.log(`%cMethod: %c${method}`, 'color: grey', 'color: black')
      if (bodyParams) {
        console.log('%cBody Params:', 'color: grey', bodyParams)
      }
      console.groupEnd()
    }
  }

  static logHeaders(headers: HeadersInit = {}) {
    if (Constants.enableRequestsLogger) {
      console.groupCollapsed('%cHeaders', 'color: black')
      Object.keys(headers).forEach((headerName) => {
        console.log(`%c${headerName}: %c${headers[headerName]}`, 'color: grey', 'color: black')
      })
      console.groupEnd()
    }
  }

  static logFormData(formData: FormData) {
    if (Constants.enableRequestsLogger) {
      console.groupCollapsed('%cForm Data', 'color: black')
      for (const [fieldName, string] of formData.entries()) {
        console.log(`%c${fieldName}: %c${string}`, 'color: grey', 'color: black')
      }
      console.groupEnd()
    }
  }

  static logResponse(logs: LogItem[]) {
    if (Constants.enableRequestsLogger) {
      console.group(`%cResponse`, 'color: black')
      logs.forEach((log) => {
        const { title, content } = log
        if (typeof content === 'string') {
          console.log(`%c${title}: %c${content}`, 'color: grey', 'color: black')
        } else {
          console.log(`%c${title}: `, 'color: grey', content)
        }
      })

      console.groupEnd()
    }
  }

  static logFinalStep() {
    if (Constants.enableRequestsLogger) {
      console.groupEnd()
    }
  }
}
